/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation deleteRelationMutation($relation: ID!) {
        payload: entityRelationRemove(relation: $relation)
    }
`;
